import { render } from "./login-with-phone.vue?vue&type=template&id=0c831b42&scoped=true"
import script from "./login-with-phone.vue?vue&type=script&lang=js"
export * from "./login-with-phone.vue?vue&type=script&lang=js"

import "./login-with-phone.vue?vue&type=style&index=0&id=0c831b42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c831b42"]])

export default __exports__